import i18next from 'i18next';

// Includes the texts of the shared TrackingTimeline, passed to it as `labels`.
i18next.addResources('es', 'tracking', {
  sectionTitle: 'Seguimiento y monitoreo',
  statusOn: 'Estado de situación {{date}}',
  totalProgress: 'Avance total',
  subStage: 'Subetapa',
  stages: 'Etapas',
  subStages: 'Sub etapas',
  inProgressSince: 'En curso desde el {{date}}',
  startedOn: 'Iniciada el {{date}}',
  expectedEnd: 'Finalización esperada: {{date}}',
  summary: 'Avance total {{progress}}. Etapa actual: {{stage}}.'
});

i18next.addResources('en', 'tracking', {
  sectionTitle: 'Tracking and monitoring',
  statusOn: 'Status as of {{date}}',
  totalProgress: 'Total progress',
  subStage: 'Sub-stage',
  stages: 'Stages',
  subStages: 'Sub-stages',
  inProgressSince: 'In progress since {{date}}',
  startedOn: 'Started on {{date}}',
  expectedEnd: 'Expected completion: {{date}}',
  summary: 'Total progress {{progress}}. Current stage: {{stage}}.'
});

i18next.addResources('pt', 'tracking', {
  sectionTitle: 'Acompanhamento e monitoramento',
  statusOn: 'Situação em {{date}}',
  totalProgress: 'Avanço total',
  subStage: 'Subetapa',
  stages: 'Etapas',
  subStages: 'Subetapas',
  inProgressSince: 'Em andamento desde {{date}}',
  startedOn: 'Iniciada em {{date}}',
  expectedEnd: 'Conclusão prevista: {{date}}',
  summary: 'Avanço total {{progress}}. Etapa atual: {{stage}}.'
});
